import { number, object } from "yup";
import { Fragments } from "requests";

export const getDisclaimer = (medCase: Fragments.StoredMedicalCase) => {
  const { disclaimer } = medCase.client;

  return {
    signature: disclaimer?.signature || null
  };
};

export const getValidationSchema = () =>
  object({
    signature: number().nullable()
  });
